<template>
  <div id="app">
    <OttawoodInvoiceSystem />
  </div>
</template>

<script>
import OttawoodInvoiceSystem from './page/OttawoodInvoiceSystem.vue'
import '@/assets/el-message-custom.css'

export default {
  name: 'App',
  components: {
    OttawoodInvoiceSystem
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  margin: 0;
  padding: 0;
  background-color: #f5f5f5;
  min-height: 100vh;
}

* {
  box-sizing: border-box;
}

body {
  margin: 0;
  padding: 0;
}
</style>
